export function getViewportMargin(amount: number): number {
    if (window.innerHeight < 1000) return 200;
    return window.innerHeight * amount;
}
